module.exports = __webpack_public_path__ + "img/av179.24ad6f88.png";